import { useStore } from 'effector-react'
import { AddEmailDrawer } from '~/entities/DriverEmail'
import { featureFlagModel } from '~/shared/lib/featureFlag'
import { useDrawer } from '~/shared/ui/Drawer'
import {
  $isProfileDrawerOpen,
  $isDriverEmailDrawerOpen,
  closeProfileDrawer,
  openDriverEmailDrawer,
  closeDriverEmailDrawer,
} from './model'

import {
  TabsDrawer,
  PassportDetailsDrawer,
  DriverLicenseDrawer,
  DriverEmailDrawer,
  DriverDeletionDetailsDrawer,
  IndividualEntrepreneurDrawer,
} from './ui'

export function Profile() {
  const isProfileOpen = useStore($isProfileDrawerOpen)
  const isDriverEmailDrawerOpen = useStore($isDriverEmailDrawerOpen)
  const featureFlags = useStore(featureFlagModel.$featureFlags)
  const [
    isPassportDetailsDrawerShow,
    passportDetailsDrawerOpen,
    passportDetailsDrawerClose,
  ] = useDrawer()

  const [isDriverLicenseShow, driverLicenseOpen, driverLicenseClose] =
    useDrawer()
  const [
    isDriverDeletionDetailsShow,
    driverDeletionDetailsOpen,
    driverDeletionDetailsClose,
  ] = useDrawer()
  const [
    isIndividualEntrepreneurShow,
    individualEntrepreneurOpen,
    individualEntrepreneurClose,
  ] = useDrawer()

  return (
    <>
      <TabsDrawer
        isShow={isProfileOpen}
        onClose={closeProfileDrawer}
        onEmailClick={openDriverEmailDrawer}
        onPassportDetailsClick={passportDetailsDrawerOpen}
        onDriverLicenseClick={driverLicenseOpen}
        onDriverDeletionDetailsClick={driverDeletionDetailsOpen}
        onIndividualEntrepreneurClick={individualEntrepreneurOpen}
      />

      <DriverEmailDrawer
        isShow={isDriverEmailDrawerOpen}
        onClose={closeDriverEmailDrawer}
      />

      <PassportDetailsDrawer
        isShow={isPassportDetailsDrawerShow}
        onClose={passportDetailsDrawerClose}
      />

      <DriverLicenseDrawer
        isShow={isDriverLicenseShow}
        onClose={driverLicenseClose}
      />

      <DriverDeletionDetailsDrawer
        isShow={isDriverDeletionDetailsShow}
        onClose={driverDeletionDetailsClose}
      />

      <IndividualEntrepreneurDrawer
        isShow={isIndividualEntrepreneurShow}
        onClose={individualEntrepreneurClose}
      />

      {featureFlags.add_email_drawer && <AddEmailDrawer />}
    </>
  )
}
